import { apply } from 'app/shared/utils';
import { IndicatorManager } from 'app/views/accessories/IndicatorManager';

export class MultiIndicatorManager<T> implements IndicatorManager<T> {
    private readonly managers: Array<IndicatorManager<T>>;

    /**
     * Another basic indicator manager implementation which takes a bunch of indicator managers and makes them appear
     * as a single indicator manager.
     */
    constructor(indicatorManagers: Array<IndicatorManager<T>>) {
        this.managers = indicatorManagers;
    }

    getCurrentIndicators(assetId: number): Array<T> {
        // simple little performance optimization to save some memory
        if (this.managers.length === 1) {
            return this.managers[0].getCurrentIndicators(assetId);
        }
        const indicators = [];
        for (const manager of this.managers) {
            indicators.push(...manager.getCurrentIndicators(assetId));
        }
        return indicators;
    }

    onChange(fn: () => void): () => void {
        const cleanups = this.managers.map((m) => m.onChange(fn));
        return () => cleanups.forEach(apply);
    }

    destroy() {
        this.managers.forEach((manager) => manager.destroy());
    }
}
